// @ts-nocheck
import { useCallback } from 'react';

import useCommon from '../useCommon.js';
import useModelInventory from './useModelInventory';

export default function useSectionPermissions() {
  const { setSectionPermissions, dispatch } = useCommon();
  const { getEntitySectionPermissions } = useModelInventory();

  const handleGetSectionPermission = useCallback(
    (params, loader = true) => {
      getEntitySectionPermissions(params, loader).then((res) => {
        if (res?.data) {
          dispatch(
            setSectionPermissions({
              entity_id: params?.entityId,
              entity_type: params?.entityType,
              data: res.data,
            })
          );
        }
      });
    },
    [setSectionPermissions, dispatch]
  );

  const handleSetSectionPermission = useCallback(
    (params) => {
      dispatch(
        setSectionPermissions({
          entity_id: params?.entity_id,
          entity_type: params?.entity_type,
          data: params?.data,
        })
      );
    },
    [dispatch]
  );

  return {
    handleGetSectionPermission,
    handleSetSectionPermission,
  };
}
